import "./CheaperInsurance.module.css";
import ToppmenyOchKontakt from "@/reusable_sections/Header";
import StarkareTillsammans from "./sections/StarkareTillsammans";
import JoinInsuranceCollective from "./sections/JoinInsuranceCollective";
import Footer from "@/reusable_sections/Footer";
export default function CheaperInsurancePage() {
  return <div>
      <ToppmenyOchKontakt />
      <StarkareTillsammans />
      <JoinInsuranceCollective />
      <Footer />
    </div>;
}